'use client';
import { motion } from 'motion/react';
import { ArrowRight } from 'lucide-react';
import DashboardMockup from './DashboardMockup';

export default function Hero() {
  return (
    <section
      id="hero"
      className="relative overflow-hidden pt-16"
      aria-labelledby="hero-heading"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        {/* Spacer */}
        <div className="pt-12 sm:pt-20 md:pt-28" />

        {/* Eyebrow */}
        <p className="text-xs font-medium uppercase tracking-[0.2em] text-muted-foreground sm:text-sm">
          Revenue Expansion Infrastructure
        </p>

        {/* THE headline — massive Fraunces */}
        <h1
          id="hero-heading"
          className="mt-5 max-w-5xl font-serif text-[2.75rem] font-700 leading-[1.05] tracking-tight text-foreground sm:text-6xl md:text-7xl lg:text-[5.5rem]"
        >
          Know exactly where
          <br />
          your next{' '}
          <span className="relative inline-block text-accent">
            &#8377;1Cr
            <svg
              className="absolute -bottom-1 left-0 w-full"
              viewBox="0 0 200 12"
              fill="none"
              aria-hidden="true"
              preserveAspectRatio="none"
            >
              <path
                d="M2 8 C50 2, 150 2, 198 8"
                stroke="hsl(30 95% 52%)"
                strokeWidth="3"
                strokeLinecap="round"
                opacity="0.5"
              />
            </svg>
          </span>{' '}
          is hiding.
        </h1>

        {/* Subtitle */}
        <p className="mt-6 max-w-xl text-base leading-relaxed text-muted-foreground sm:mt-8 sm:text-lg">
          The leadership console that replaces your 90&#8209;minute morning
          ritual of Excel, WhatsApp, and gut feel with{' '}
          <strong className="font-semibold text-foreground">
            10 minutes of clarity.
          </strong>
        </p>

        {/* CTAs */}
        <div className="mt-8 flex flex-wrap items-center gap-4 sm:mt-10">
          <a
            href="#cta"
            className="inline-flex items-center gap-2.5 rounded-full bg-foreground px-7 py-3.5 text-sm font-semibold text-background transition-opacity hover:opacity-85 focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
          >
            Request a Demo
            <ArrowRight className="h-4 w-4" aria-hidden="true" />
          </a>
          <a
            href="#product"
            className="inline-flex items-center gap-2 text-sm font-semibold text-foreground underline decoration-border underline-offset-4 transition-colors hover:decoration-foreground"
          >
            See how it works
          </a>
        </div>

        {/* Product mockup — the hero visual */}
        <motion.div
          className="relative mt-16 sm:mt-20 md:mt-24"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        >
          {/* Warm glow behind mockup */}
          <div
            className="absolute -inset-8 -z-10 rounded-3xl opacity-50 blur-3xl sm:-inset-12"
            aria-hidden="true"
            style={{
              background:
                'radial-gradient(ellipse at 50% 40%, hsl(30 95% 52% / 0.10), transparent 70%)',
            }}
          />
          <DashboardMockup />
        </motion.div>

        {/* Bottom spacer */}
        <div className="h-16 sm:h-20" />
      </div>
    </section>
  );
}
